import "./GetStarted.module.css";
import Header from "@/reusable_sections/Header";
import StartYourJourney from "./sections/StartYourJourney";
import IntakeForm from "./sections/IntakeForm";
import Footer from "@/reusable_sections/Footer";
export default function GetStartedPage() {
  return <div>
      <Header />
      <StartYourJourney />
      <IntakeForm />
      <Footer />
    </div>;
}